import React from 'react';
import cx from 'classnames';
import dateformat from 'dateformat';
import { Row, Col, Modal, ProgressBar, Popover, OverlayTrigger } from 'react-bootstrap';
import DataSourceService from 'src/legacy/services/datasource.service.jsx';
import DataSourceRow from "./DataSourceRow.jsx";
import commonStyles from '../Styles.module.scss';
import styles from './dataSourceView.module.scss';
import buildUrl from 'build-url-ts';
import EventService from "src/services/event.service.jsx";
import DataSourceMigrationStatusContainer from './migration';
import RssFeedDetailContainer from './RssFeedDetailContainer.jsx';
import isEqual from 'is-equal';
import { toast } from 'react-toastify';
import { localizedStrings } from 'src/localization/index.jsx';
import subscriptionPlanService from 'src/services/subscriptionPlan.service.js';
import _ from 'lodash';
import PlaceholderEmptyMessage from 'src/components/placeholderEmptyMessage/index.jsx';

const ContactListEmptyMessage = '/images/contactListEmptyMessage.svg'

const apiUrl = `${process.env.REACT_APP_API_URL}`;

class DataSourceView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      sourceType: '',
      expandRssView: false,
      rssFeedUrl: '',
      urlError: '',
      assetType: {},
      paperfliteAssetMetaData : {},
      contentSourceAssetMetaData: {},
      hovered: false,
      migratedDataSource: {},

    }

    this._renderSources = this._renderSources.bind(this);
    this.handleSourceAuthenticate = this.handleSourceAuthenticate.bind(this);
    this.handleCodeRecievedEvent = this.handleCodeRecievedEvent.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this._handleChange = this._handleChange.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedContentSources = this.localizedSettings.content_sources;
  }

  componentDidMount() {
    this.props.fetchDataSource();

    this.props.fetchAssetStorageLimit();

    this.setState({
      assetType : {name : this.localizedSettings.paperflite, value: "Paperflite"}
    })
    
  }

  componentWillReceiveProps(nextProps) {
   
    if(!_.isEqual(this.props.storageLimit, nextProps.storageLimit))
    {
      this.calculateStorageLimitMetaData(nextProps);
    }

    if(!_.isEqual(this.props.dataSources, nextProps.dataSources)){
      if (this.state.migratedDataSource && nextProps.dataSources.some(source => source.id === this.state.migratedDataSource && source.migrated)) {
        const migratedSource = nextProps.dataSources.find(source => source.id === this.state.migratedDataSource);
        toast(<DataSourceMigrationStatusContainer datasource={migratedSource} />);
      }
    }


    if(_.get(nextProps.oauth2, "rss.authenticated")){
      this.setState({
        expandRssView: false
      })
    }

    if(_.get(nextProps.oauth2, "rss.error")){
      this.setState({
        urlError: nextProps.oauth2.rss.error.errors[0].message
      })
    }

  }

  handleMigrate(source) {
   
    this.setState({
      migratedDataSource: source.id
    }, () => {
      this.props.migrateDataSource({id: source.id});
    })
  }
  render() {

    return (
      <div className={commonStyles.rightContent}>
        <div className={styles.sourceTitle}><div className={styles.titleText}>{this.localizedContentSources.title}</div></div>
        <ul className={styles.typeList}>
          {this._renderSourceTypes()}
        </ul>

        {this.state.expandRssView &&
          <RssFeedDetailContainer onChange={this._handleChange} onSave={this.handleSave} onCancel={this.handleCancel} urlError={this.state.urlError} />
        }
        <div className={cx(styles.connectedSources, { [styles.selected]: this.state.expandRssView })}> <div className={styles.subTitleText}>{this.localizedContentSources.connected_sources}</div>
          <div className={styles.sourcesContainer} style={{ height: '100%'  }}>
            {this._renderSources()}
            {_.size(this.props.dataSources) === 0 && <div className={styles.emptyMessage}>
              {this.props.isFetching && <p className={styles.loadingMessage}> {this.localizedCommonLoading.loading}... </p>}
              {!this.props.isFetching && <PlaceholderEmptyMessage
                title={this.localizedContentSources.empty_message.title}
                message={this.localizedContentSources.empty_message.description}
                image={ContactListEmptyMessage}
                className={styles.emptyMessageIcon}
                visible={true}
              />}
            </div>}
          </div>
        </div>
        
        {!subscriptionPlanService.isLegacyPlan() && this.renderStorageTracker()}
        <Modal show={this.props.isAuthenticating(this.state.sourceType)} backdrop={true} className={styles.processingModal}>
          <Modal.Body>
            <div className={styles.processingMessage}>{this.localizedContentSources.processing_response}...</div>
          </Modal.Body>
        </Modal>
        
      </div>


    )
  }

  renderStorageTracker() {
    return ( <div onMouseEnter={() => this.setState({ hovered: true })}
      onMouseLeave={() => this.setState({ hovered: false })}
      className={styles.storageTracker}
      style={{ height: this.state.hovered ? '8.325rem' : '7rem' }}>

      {this.props.isStorageLimitFetching && <div className={styles.loading}>Loading...</div>}
      {!this.props.isStorageLimitFetching && <div className={styles.storageUsed}>

        {this.isPaperflite() && this.state.paperfliteAssetMetaData && `${this.state.paperfliteAssetMetaData.used}GB of / ${this.state.paperfliteAssetMetaData.total}GB used`}

        {this.isContentSource() && this.state.contentSourceAssetMetaData && `${this.state.contentSourceAssetMetaData.used} of / ${this.state.contentSourceAssetMetaData.total} Asset used`}
      </div>}
      <div className={styles.titleContainer}>

        <span>{this.localizedContentSources.storage_limit} </span>
        {!this.props.isStorageLimitFetching && <span className={styles.dropDownContainer}>{this.renderAssetTypeFilter()}</span>}

      </div>

      {!this.props.isStorageLimitFetching && <div className={styles.progressDiv}>

        {this.isPaperflite() && this.state.paperfliteAssetMetaData && (
          <ProgressBar now={this.state.paperfliteAssetMetaData.progress} />
        )}

        {this.isContentSource() && this.state.contentSourceAssetMetaData && (
          <ProgressBar now={this.state.contentSourceAssetMetaData.progress} />
        )}
      </div>}
      {!this.props.isStorageLimitFetching && <div className={styles.circleTextContainer}>
        <span>
          <span className={styles.totalCircle} style={{ display: this.state.hovered ? 'inline-block' : 'none' }}></span>
          <span className={styles.totalHelpText} style={{ display: this.state.hovered ? 'inline-block' : 'none' }}>
            {this.isPaperflite() ? this.localizedContentSources.total_consumption : this.localizedContentSources.total_assets_uploaded}
          </span>


          <span className={styles.percentage} style={{ display: this.state.hovered ? 'inline-block' : 'none' }}>(
            {this.isPaperflite() && this.state.paperfliteAssetMetaData && `${this.state.paperfliteAssetMetaData.progress}%`}

            {this.isContentSource() && this.state.contentSourceAssetMetaData && this.state.contentSourceAssetMetaData.used}
            )
          </span>
        </span>


        <span className={styles.limitContainer}>
          <span className={styles.limitCircle} style={{ display: this.state.hovered ? 'inline-block' : 'none' }}></span>
          <span className={styles.limitHelpText} style={{ display: this.state.hovered ? 'inline-block' : 'none' }}>
            {this.isPaperflite() ? this.localizedContentSources.remaining_limit : this.localizedContentSources.remaining_asset_limit}
          </span>

          <span className={styles.percentage} style={{ display: this.state.hovered ? 'inline-block' : 'none' }}>(
            {this.isPaperflite() && this.state.paperfliteAssetMetaData && `${this.state.paperfliteAssetMetaData.remaining}%`}

            {this.isContentSource() && this.state.contentSourceAssetMetaData && this.state.contentSourceAssetMetaData.remaining}
            )
          </span>

        </span>

      </div>}
    </div>)
  }

  isPaperflite() {
    return _.get(this.state, 'assetType.value', "") === 'Paperflite';
  }

  isContentSource() {
    return _.get(this.state, 'assetType.value', "") === 'Content Source'
  }


  calculateStorageLimitMetaData(nextProps) {

    const paperfliteAssetMetaData = {};
  
      const paperfliteStorageLimit = _.get(nextProps, "storageLimit.paperfliteAssets.assetStorageLimit", null);
      const paperfliteStorageUsed = _.get(nextProps, "storageLimit.paperfliteAssets.assetStorageUsed", null);
    
      if (paperfliteStorageLimit !== null && paperfliteStorageUsed !== null) {
        var usedPercentage = ((paperfliteStorageUsed / paperfliteStorageLimit) * 100).toFixed(2);
        const remainingPercentage = (100 - usedPercentage).toFixed(2);

        if (usedPercentage > 100) {
          usedPercentage = 100.00;
        }

        paperfliteAssetMetaData.progress = usedPercentage
        paperfliteAssetMetaData.used = paperfliteStorageUsed;
        paperfliteAssetMetaData.remaining = usedPercentage == 100.00 ? 0.00 : remainingPercentage;
        paperfliteAssetMetaData.total = paperfliteStorageLimit;
    
        this.setState({
          paperfliteAssetMetaData
        });
      }
    
      const contentSourceAssetMetaData = {};
    
      const contentSourceLimit = _.get(nextProps, "storageLimit.contentSource.datasourceFilesLimit", null);
      const contentSourceUsed = _.get(nextProps, "storageLimit.contentSource.datasourceFilesUsed", null);
    
      if (contentSourceLimit !== null && contentSourceUsed !== null) {
        var usedPercentage = (contentSourceUsed / contentSourceLimit) * 100;

        var remaining;
        if (contentSourceUsed > contentSourceLimit) {
          remaining = 0;
        } else {
          remaining = contentSourceLimit - contentSourceUsed;
        }

        contentSourceAssetMetaData.progress = usedPercentage
        contentSourceAssetMetaData.used = contentSourceUsed;
        contentSourceAssetMetaData.remaining = remaining;
        contentSourceAssetMetaData.total = contentSourceLimit;
    
        this.setState({
          contentSourceAssetMetaData
        });
      }

  }
  
  _renderSourceTypes() {
    var dataSources = DataSourceService.instance.dataSources;

    return dataSources.map((dataSource, index) => (
      <li
        key={index} className={styles.addsource} onClick={() => this.handleSourceAuthenticate(dataSource)}>
        <div>
          <img
            src={dataSource.icon} alt="" className={cx(dataSource.class, styles.contentImages)} />
        </div>
        <div className={cx(styles.sourcename, { [styles.selection]: this.state.expandRssView && dataSource.id === 'rss' })} >{dataSource.name}</div>
      </li>
    ));
  }

  _renderSources() {
    var rows = Array();
    this.props.dataSources.forEach((source, index) => {
      let migrationStatus = source.migrationStatus;

      rows.push(
        <DataSourceRow name={source.name}
          key={source.id}
          id={source.id}
          streams={source.streams}
          assets={source.assets}
          updateDate={dateformat(source.modifiedDate, 'dd mmm yyyy')}
          syncStatus={source.syncStatus}
          storageType={source.storageType}
          syncSource={this.props.syncSource}
          deleteSource={this.props.deleteSource}
          isSynchronising={source.synchronising}
          migrationStatus={migrationStatus}
          migrateDataSource={this.handleMigrate.bind(this, source)}
          lastMigrationDate={source.lastMigrationDate}
          handleSourceAuthenticate={() => this.handleSourceAuthenticate(source)}
        />
      )
    });

    return rows;
  }

  handleSourceAuthenticate(dataSource) {

    this.props.trackAdoptionMetricsForSourceTypeSelectedEvent(dataSource.name);
    if (dataSource.storageType != 'rss') {
      //Calculate Position
      var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.left;
      var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.top;

      var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.width;
      var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.height;

      var w = 0.8 * width;
      var h = 0.8 * height;

      var left = ((width / 2) - (w / 2)) + dualScreenLeft;
      var top = ((height / 2) - (h / 2)) + dualScreenTop;

      const url = buildUrl(apiUrl, {
        path: `datasources/${dataSource.storageType}/authorize`
      })

      var newWindow = window.open(url, `Authorize ${dataSource.name} Account`, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

      // Puts focus on the newWindow
      if (newWindow.focus) {
        newWindow.focus();
      }

      //Attaching message event listner
      var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
      var eventer = window[eventMethod];
      var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

      this.setState({
        sourceType: dataSource.storageType
      })

      eventer(messageEvent, this.handleCodeRecievedEvent, false);

      return false;

    } else {
      this.setState({
        sourceType: dataSource.storageType,
        expandRssView: true
      });
    }
  }

  renderAssetTypeFilter() {
    var fields = [
      {
        name: this.localizedSettings.paperflite,
        value: "Paperflite",
      },
      {
        name: this.localizedSettings.content_source,
        value: "Content Source",
      }
    ];
  
    var options = fields.map((field, index) => {
      var selectedValue = isEqual(this.state.assetType.value, field.value);
      return (
        <li
          key={index}
          onMouseEnter={() => this.setState({ hovered: true })}
          onMouseLeave={() => this.setState({ hovered: false })}
          className={cx(styles.option, { [styles.active]: selectedValue })}
          onClick={() => this.handleOptionSelection(field)}
        >
          <span className={styles.type}>{field.name}</span>
        </li>
      );
    });
  
    var popoverMenu = (
      <Popover id="asset_type__popover" className={styles.popover}>
        <div
          className={styles.assetTypeDropdown}
          onMouseLeave={() => this.setState({ hovered: false })}
        >
          <ul>{options}</ul>
        </div>
      </Popover>
    );
    return (
      <div className={styles.assetType}>
        <OverlayTrigger
          trigger="click"
          placement="bottom"
          overlay={popoverMenu}
          rootClose
        >
          <div className={styles.button}>
            <img
              className={styles.filterList}
            />
            <span className={styles.type}>{this.state.assetType.name}</span>
            <i className={cx(styles.faSize, "fa fa-angle-down")}></i>
          </div>
        </OverlayTrigger>
      </div>
    );
  }
  
  handleOptionSelection(field) {
    document.body.click(); 
  
    var newRequest = {
      ...this.state.request,
      assetType: field.value,
    };
  
    this.setState({
      assetType: field,
      request: newRequest
    });
  }
  
  handleCodeRecievedEvent(e, sourceType) {

    //Removing message event listner
    var detachEventMethod = window.removeEventListener ? 'removeEventListener' : 'detachEvent';
    var deEventer = window[detachEventMethod];
    var messageEvent = detachEventMethod == "detachEvent" ? "onmessage" : "message";

    if (e.data.type == 'DATA_SOURCE_AUTHORIZATION_SUCCESS') {
      var code = e.data.payload.code;
      var state = e.data.payload.state;
      var error = e.data.payload.error;
      var sourceType = EventService.getSourceType(this.state.sourceType);
      this.props.trackAdoptionMetricsForSourceConnectedEvent(sourceType);

      if (!error) {
        this.props.authenticateDataSource({sourceType: this.state.sourceType, code});
      }

      deEventer(messageEvent, this.handleCodeRecievedEvent, false);
    }
  }

  handleSave() {
    this.props.createRssDataSource({sourceType: this.state.sourceType, rssUrl: this.state.rssFeedUrl})
  }

  handleCancel() {
    this.setState({
      urlError: '',
      expandRssView: false
    })
  }

  _handleChange(e) {
    let url = e.target.value;
    this.setState({
      urlError: '',
      rssFeedUrl: url.trim()
    });
  }
}

export default DataSourceView;